<template>
  <AnimationComponent>
    <section class="max-w-content mx-auto" :class="reducePaddingTopBottom ? 'py-2' : 'py-24'">
      <div :class="{ 'md:px-8': addPaddingX }">
        <div
          :class="`bg-${color} md:rounded-2xl p-8 md:p-16 flex flex-col md:flex-row md:flex-wrap gap-8 items-start justify-between`"
        >
          <div class="flex-1 md:max-w-xl flex flex-col gap-4">
            <h2 class="text-3xl font-semibold leading-[38px] text-white">{{ title }}</h2>
            <p class="text-md md:text-xl leading-[30px] text-grey-dark-300">
              {{ description }}
            </p>
          </div>
          <div v-if="showTalkToSales" class="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <router-link :to="{ name: 'business-enquiry' }" class="w-full md:w-auto" :class="{ 'order-2 sm:order-1': reverseButtons }">
              <Button size="business" class="w-full md:w-auto" :variant="learnMoreVariant">Learn more</Button>
            </router-link>
            <router-link :to="{ name: 'business-enquiry', hash: '#enquiry-form' }" class="w-full md:w-auto" :class="{ 'order-1 sm:order-2': reverseButtons }">
              <Button size="business" class="flex-1 md:flex-initial w-full md:w-auto">Talk to sales</Button>
            </router-link>
          </div>
          <div v-else class="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <router-link :to="{ name: 'business-enquiry' }">
              <Button variant="outline" size="lg" class="py-6 cursor-pointer flex-auto min-w-0">Learn more</Button>
            </router-link>

            <a :href="signUpUrl">
              <Button size="lg" class="py-6 cursor-pointer flex-auto min-w-0">Get Started</Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  </AnimationComponent>
</template>

<script setup lang="ts">
import { Button, type ButtonVariants } from '@/components/ui/button';
import { DASHBOARDS_URL } from '@/config';
import { computed } from 'vue';
import AnimationComponent from '../AnimationComponent.vue';

interface Props {
  color?: string;
  title: string;
  description: string;
  showTalkToSales?: boolean;
  reducePaddingTopBottom?: boolean;
  reverseButtons?: boolean;
  learnMoreVariant?: ButtonVariants['variant'];
  addPaddingX?: boolean
}

withDefaults(defineProps<Props>(), {
  color: 'brand-900',
  showTalkToSales: true,
  reducePaddingTopBottom: false,
  reverseButtons: false,
  learnMoreVariant: 'outline',
  addPaddingX: true,
});

const signUpUrl = computed((): string => {
  return `${DASHBOARDS_URL}/merchant/auth/sign-up`;
});
</script>
